import { Skeleton } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import axios, { AxiosRequestConfig } from 'axios'
import { AppBox, AppButton, AppTypography, PhoneField, PhoneText } from 'components'
import { ApiQueryKeys } from 'globals/constants'
import { enqueueSnackbar } from 'notistack'
import { FC, useEffect, useState } from 'react'
import { ParkAddressInfoViewModel, ParkSitesApi, SdkConfig } from 'sdk'
import { AppStore } from 'store/app.store'

interface Props {
  onParkRemove: () => void
  parkId: string
  isLinkedOnly?: boolean
}

export const CrmContactLinkedParksitesRemoveDialog: FC<Props> = ({ onParkRemove, parkId, isLinkedOnly }) => {
  const [isReady, setIsReady] = useState(false)
  const [apiData, setApiData] = useState<ParkAddressInfoViewModel>()
  const authorizeRequest = () => {
    const SessionValue = AppStore.getState().Auth.CurrentUser
    return `Bearer ${SessionValue ? SessionValue.JwtToken : ''}`
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers: AxiosRequestConfig['headers'] = {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: authorizeRequest(),
        }
        const response = await axios.get(`${SdkConfig.ApiPath}/ParkSites/GetParkAddressInfo/${parkId}`, { headers })
        setApiData(response.data.Data)
        setIsReady(true) // Enable the add function after data is fetched
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [parkId])
  return (
    <>
      {!isReady ? (
        <>
          <Skeleton height={40} width={100} />
          <Skeleton height={30} width={70} />
          <Skeleton height={30} width={70} />
        </>
      ) : (
        <AppBox backgroundColor="primary.200">
          <AppTypography fontSize={16} fontWeight={600}>
            {apiData?.ParkName}
          </AppTypography>
          {apiData?.Address && <AppTypography color={'grey.500'}>{apiData?.Address}</AppTypography>}
          {apiData?.Phone && (
            <AppTypography color={'grey.500'}>
              Park Phone: <PhoneText phone={apiData?.Phone} />
            </AppTypography>
          )}
          <AppBox textAlign={'right'} If={!isLinkedOnly}>
            <AppButton onClick={onParkRemove}>Remove</AppButton>
          </AppBox>
        </AppBox>
      )}
    </>
  )
}
